import {global} from "../constants";

// A ceg szlogenje - egy helyen tartjuk, hogy a fejlec, a hero es a lablec
// mindig ugyanazt mutassa.
export const slogan = "Velünk akár a Holdra is!";

// Szezonalis akcio. Szandekosan nincs hozza datum: amig a `active` true,
// addig latszik az oldalon. Kikapcsolashoz eleg false-ra allitani.
export const promo = {
    active: true,
    percent: "10%",
    // A `now` az idobeli surgetes miatt van kiemelve: az akcionak nincs
    // vegdatuma, de erzodjon, hogy eppen most el.
    now: "MOST",
    title: "Szezonális akció",
    text: "Minden szolgáltatásunkra",
    note: "Az akció visszavonásig, hétköznapokra, előzetes egyeztetés alapján érvényes és más kedvezménnyekkel nem vonható össze."
};

// Tovabbajanlasi "cashback". Sikeres - azaz teljesult - megbizas utan fizetjuk.
export const referral = {
    active: true,
    amount: "5 000 Ft",
    title: "Ajánlja másnak is!",
    text: "Nagyon hálásak vagyunk minden továbbajánlásért! Ha az Ön ajánlása nyomán új megrendelés születik, és azt el is végezzük,",
    note: "Az ajánlást a megrendeléskor kell jeleznie az új ügyfélnek. A visszatérítést a megbízás teljesítése után fizetjük ki. A részletekről érdeklődjön munkatársainknál."
};

export const data = {
    whatwedo: {
        title: "Rólunk",
        subtitle: "Költöztetők akikben megbízhat az ember",
        description: "Költöztetés, bútorszállítás és lomtalanítás <b>Budapesten</b> és akár az ország egész területén. Kedvező díjak, szakemberek által irányított és végrehajtott költöztetés, szállítás, lomtalanítás, tehertaxi. Valódi minőség, ár-érték arányunk pedig kimagasló. Egy tételt is szívesen elszállítunk, de elköltöztetünk egész lakásokat, házakat, irodaházakat is. Mindkét esetben kiváló szolgáltatás jár Ügyfeleinknek kedvező áron a megbízás nagyságától függetlenül. Jó hírünket sok-sok visszatérő Ügyfelünk erősíti, köszönjük!",
        image: global.icons + "img1.png",
        works: [
            {
                icon: global.icons + "pic1.png",
                serial: "01.",
                title: "Költöztetés",
                description: "Legyen budapesti vagy vidéki költöztetés, kollégáink már rutinos helyismerettel rendelkeznek."
            },
            {
                icon: global.icons + "pic2.png",
                serial: "02.",
                title: "Bútorszállítás",
                description: "A bútorszállítás akkor hasznos, ha költözni szeretnél, vagy új bútort vásároltál, és el kell juttatnod az otthonodba. A bútorszállítók gondoskodnak a bútorok csomagolásáról, szereléséről, szállításáról, és kipakolásáról, így neked nem kell aggódnod a sérülés vagy a helyhiány miatt."
            },
            {
                icon: global.icons + "pic5.png",
                serial: "03.",
                title: "Lomtalanítás",
                description: "Feleslegessé vált bútorok, háztartási gépek és lomok elszállítása lakásból, pincéből, padlásról vagy udvarról. Kipakolunk, felrakodunk és gondoskodunk a hulladék szabályszerű elhelyezéséről – Önnek csak meg kell mutatnia, mi mehet."
            },
            {
                icon: global.icons + "pic3.png",
                serial: "04.",
                title: "TeherTaxi",
                description: "Ha egy vagy néhány tárgyat kell szállítanod, amit nem tudsz a személyautódban elhelyezni. A tehertaxi gyors és rugalmas megoldás, amit akár azonnal is igénybe vehetsz."
            },
            {
                icon: global.icons + "pic9.png",
                serial: "05.",
                title: "Áruszállítás",
                description: "Az ipari, kereskedelmi egységekben gyakran előfordul, hogy bizonyos termékeket el kell szállítani az egyik telephelyről a másikra, vagy az egymástól távol lévő raktárhelyiségek között kell mozgatni. Ilyenkor biztosítani kell minden feltételt ahhoz, hogy az áru biztonságosan elérjen a célállomásra a megadott időn belül."
            }
        ]
    },

    whychooseus: {
        background: global.back + "bg-1.jpg",
        title: "Miért minket válasszon?",
        subtitle: "Költöztetés mesterfokon",
        description: {
            short: "Az egyszerűtől a legbonyolultabb munkáig – ránk mindig, minden körülmények között számíthat!",
            long: "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium dolorem que laudantium, totam rem aperiam, que ipsa quae ab illo inventore veritatis quasi architecto beatae itae dicta sunt explicabo. Nemo enim ipsam voluptate voluptas sitr atur aut odit aut fugit, sed quia consequuntur magni dolores is eos qui ratione voluptatem sequi nesciunt."
        },
        pic1: global.whyChoose + "pic22.jpeg",
        pic2: global.whyChoose + "pic2.jpg",
        help: {
            icon: global.whyChoose + "qt-icon.png",
            number: "(+36 30 111 2233)"
        }
    },

    booking: {
        background: global.booking + "bg-map.png",
        image: global.booking + "pic1.png",
        imageBack: "",
        title: "Request A Quote",
        subtitle: "Booking For Product Transformation",
        description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry the standard dummy text ever since the when an printer took.",
        form: {
            quote: global.booking + "icon1.png",
            track: global.booking + "icon2.png"
        }
    },

    estimation: {
        background: global.back + "bg-2.jpg",
        title: "Gyors és egyszerű megoldás",
        subtitle: "A nap 24 órájában elérhetőek vagyunk, megfizethetők az áraink, nincsenek rejtett költségeink.",
        description: "Hívjon minket és a részletes információk alapján már személyre szabottan tudunk Önnek ajánlatot adni arra vonatkozólag, hogy a megrendelni kívánt költöztetés milyen költségekkel jár, milyen teendők szükségesek a költöztetést megelőzően, mibe, hogyan csomagoljon, mennyi időt vesz igénybe és milyen méretű teherautó szükséges.",
        solutions: [
            {
                serial: "01",
                title: "Hívjon minket!",
                subtitle: "7/24 elérhetőek vagyunk"
            },
            {
                serial: "02",
                title: "Kedvező árajánlat",
                subtitle: "Megfizethetők az áraink, nincsenek rejtett költségeink"
            },
            {
                serial: "03",
                title: "Megyünk és költöztetjük",
                subtitle: "Számunkra első a biztonság, ezért kizárólag kifogástalan műszaki állapotban lévő autókkal dolgozunk"
            }
        ]
    },

    testimonials: {
        title: "Respected",
        subtitle: "Clients & partners",
        clients: [
            global.logo + "/w1.png",
            global.logo + "/w2.png",
            global.logo + "/w3.png",
            global.logo + "/w4.png",
            global.logo + "/w5.png",
            global.logo + "/w6.png",
        ],
        partners: [
            {
                pic: global.testim + "pic1.jpg",
                quote: "Nemo enim ipsam voluptate voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratio ne voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi",
                name: "Peter Len",
                designation: "Web Designer"
            },
            {
                pic: global.testim + "pic2.jpg",
                quote: "Nemo enim ipsam voluptate voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratio ne voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi",
                name: "Giselle",
                designation: "Developer"
            },
            {
                pic: global.testim + "pic3.jpg",
                quote: "Nemo enim ipsam voluptate voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratio ne voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi",
                name: "Josephine",
                designation: "Web Designer"
            },
            {
                pic: global.testim + "pic4.jpg",
                quote: "Nemo enim ipsam voluptate voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratio ne voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi",
                name: "Penelope",
                designation: "Developer"
            }
        ]
    },

    services: {
        title: "Szolgáltatásaink",
        subtitle: "Minden megbízást egyedi kihívásnak tekintünk és igény szerint a csomagolástól az összeszerelésig mindenben segítséget nyújtunk!",
        description: "Költöztetés teljes folyamata alatt munkánkra és az Ön értéktárgyaira szállítás közbeni garanciát vállalunk! Így Ön teljes biztonságban tudhatja minden vagyontárgyát!",
        services: [
            {
                image: global.sgallery + "1.jpg",
                title: "Költöztetés",
                serial: "01",
                description: "A költöztetés egy komplex szolgáltatás, amely a lakások, irodák, üzletek vagy egyéb helyiségek teljes vagy részleges átköltöztetését jelenti. A költöztetés magában foglalhatja a bútorok és a személyes tárgyak csomagolását, szállítását, rakodását, kirakodását, elhelyezését és kicsomagolását is"
            },
            {
                image: global.sgallery + "2.jpg",
                title: "Bútorszállítás",
                serial: "02",
                description: "A bútorszállítás során a bútorokat a megadott címről a kívánt helyre szállítják, akár lakásba, irodába, nyaralóba vagy raktárba. A bútorszállítás magában foglalhatja a bútorok csomagolását, szerelését, beállítását és védelmét is"
            },
            {
                image: global.sgallery + "5.jpg",
                title: "Lomtalanítás",
                serial: "03",
                description: "A lomtalanítás során a feleslegessé vált bútorokat, háztartási gépeket, elektronikai eszközöket és egyéb lomokat szállítjuk el lakásból, pincéből, padlásról, garázsból vagy udvarról. Vállaljuk teljes lakás- és hagyatéki kiürítést is: a kipakolástól a felrakodáson át a hulladék szabályszerű elhelyezéséig mindent elintézünk"
            },
            {
                image: global.sgallery + "3.jpg",
                title: "TeherTaxi",
                serial: "04",
                description: "A tehertaxi egy gyors és rugalmas szállítási megoldás, amely kisteherautóval vagy furgonnal végzi el a fuvarfeladatokat. A tehertaxi alkalmas kisebb áruk, csomagok, raklapok, háztartási gépek vagy egyéb tárgyak szállítására, akár azonnal is"
            },
            {
                image: global.sgallery + "4.jpg",
                title: "Áruszállítás",
                serial: "05",
                description: "Az áruszállítás egy olyan szolgáltatás, amely nagyobb mennyiségű vagy súlyú árukat szállít teherautóval vagy kamionnal. Az áruszállítás alkalmas a cégek, a beszerzők, a gyártók, a kereskedők vagy a magánszemélyek közötti áruáramlás biztosítására, akár országon belül, akár külföldre is"
            },
        ]
    },

    approach: {
        title: "Cégünkről",
        subtitle: "Legyen szó költözésről, bútorszállításról, lomtalanításról, tehertaxiről vagy áruszállításról",
        yearsOfExperience: "5",
        specifications: [
            {
                icon: global.icons + "c-pic1.png",
                count: 190,
                title: "Elégedett ügyfél"
            },
            {
                icon: global.icons + "c-pic2.png",
                count: 250,
                title: "Sikeres megbízás"
            },
            {
                icon: global.icons + "c-pic3.png",
                count: 2,
                title: "Teherautó"
            }
        ]
    },

    blogs: {
        title: "Blog",
        subtitle: "Tippek, történetek és hasznos tanácsok a költözés világából",
        description: "Költözni nem mindig egyszerű, de mi segítünk! Böngéssz legújabb bejegyzéseink között, és tudd meg, hogyan lehet gördülékenyebb a folyamat.",
        blogs: [
            {
                id: 1,
                image: global.blog1 + "bg1.jpg",
                day: "10",
                month: "Márc",
                tags: [
                    "Költöztetés",
                    "Fufarozás",
                    "TeherTaxi",
                    "Csomagok ",
                    "Teherautó",
                ],
                blockquote: "Az új kezdet mindig egy bátor lépéssel indul.",
                title: "Stresszmentes költözés 7 egyszerű lépésben",
                short_description: "Tudd meg, hogyan csökkentheted a költözés okozta stresszt egyszerű, de hatékony lépésekkel.",
                description: `
      <p>A költözés sokak számára az egyik legstresszesebb élethelyzet, pedig némi tervezéssel könnyedén gördülékennyé tehető. A legfontosabb, hogy időben kezdjünk el készülni. Már hetekkel a költözés előtt érdemes elkezdeni a kevésbé használt tárgyak összepakolását, és fokozatosan haladni a napi szinten szükséges eszközök felé.</p>
      <p>A részletes költözési ütemterv segít átlátni, hogy melyik nap mit kell elintézni. Érdemes külön figyelmet fordítani az értékesebb tárgyak biztonságos csomagolására, valamint a költözés napján szükséges alapvető dolgok (pl. iratok, töltők, váltóruha) elkülönítésére.</p>
      <div class="post-single-list">
        <ul class="description-list">
          <li><i class="fa fa-angle-right"></i> Időben kezdj csomagolni a kevésbé használt tárgyakkal.</li>
          <li><i class="fa fa-angle-right"></i> Készíts részletes költözési ütemtervet és checklistát.</li>
          <li><i class="fa fa-angle-right"></i> Címkézd a dobozokat világosan és olvashatóan.</li>
          <li><i class="fa fa-angle-right"></i> Tervezz pihenőidőt a költözés napjára is!</li>
        </ul>
      </div>
      <p>Ne feledd, a profi költöztetők nemcsak időt spórolnak, hanem a biztonságos szállításban is segítenek. Egy tapasztalt csapat mellett a költözés is sokkal gördülékenyebb lesz, így Te is nyugodtabban élvezheted új otthonodba való beköltözést.</p>
    `
            },
            {
                id: 2,
                image: global.blog1 + "bg2.jpg",
                day: "22",
                month: "Ápr",
                tags: [
                    "Költöztetés",
                    "Fufarozás",
                    "TeherTaxi",
                    "Csomagok ",
                    "Teherautó",
                ],
                blockquote: "A jó tervezés fél siker – költözéskor különösen igaz ez.",
                title: "Költözés költségei – Milyen rejtett kiadásokra figyelj?",
                short_description: "Ne érjen meglepetés: tudd meg, milyen extra költségek merülhetnek fel egy költözés során!",
                description: `
      <p>Sokan csak a költöztető cég alapdíjára figyelnek, pedig a költözés során számos egyéb költség is felmerülhet. Például városi környezetben sokszor parkolási engedély szükséges a teherautó számára, amit külön díj ellenében lehet beszerezni. Emellett, ha a lift nem használható, vagy sok lépcsőn kell cipekedni, az extra munkadíjat jelenthet.</p>
      <p>Ne feledkezzünk meg a bútorszerelésről sem. Nagyobb szekrényeket, ágyakat gyakran szét kell szerelni a szállításhoz, és ez plusz idővel és költséggel járhat. Ha különösen értékes vagy törékeny tárgyakat is költöztetünk (például zongora, antik bútor), érdemes extra biztosítást kötni, hogy teljes nyugalomban tudjuk áthelyeztetni őket.</p>
      <p>Végül sokan megfeledkeznek arról, hogy az új helyre történő beköltözés után takarítási, karbantartási kiadások is adódhatnak. Ha előre számolsz ezekkel a költségekkel, nem érhet kellemetlen meglepetés a költözés napján.</p>
    `
            },
            {
                id: 3,
                image: global.blog1 + "bg3.jpg",
                day: "05",
                month: "Máj",
                tags: [
                    "Költöztetés",
                    "Fufarozás",
                    "TeherTaxi",
                    "Csomagok ",
                    "Teherautó",
                ],
                blockquote: "Az igazi bátorság nem az, hogy elindulsz – hanem hogy minden időben célba érsz.",
                title: "Télen költözni? Így lesz biztonságos és hatékony",
                short_description: "Téli költözés? Ne aggódj! Tippek, hogyan készülj fel az időjárási kihívásokra és tedd gördülékennyé a folyamatot.",
                description: `
      <p>A téli költözés sokak számára ijesztőnek tűnhet, de megfelelő előkészítéssel ugyanolyan sikeres lehet, mint bármely más évszakban. Az első lépés, hogy folyamatosan figyeld az időjárás-előrejelzést, és legyél rugalmas az időpont módosításában, ha szükséges. Hóesés vagy jég esetén különösen fontos a biztonság.</p>
      <div class="post-single-list">
        <ul class="description-list">
          <li><i class="fa fa-angle-right"></i> A fel- és lerakodási területet tisztítsd meg a hótól és jégtől.</li>
          <li><i class="fa fa-angle-right"></i> Használj csúszásmentes szőnyegeket és takarókat a biztonság érdekében.</li>
          <li><i class="fa fa-angle-right"></i> Csomagolj plusz fóliával, hogy megóvd a bútorokat a nedvességtől.</li>
        </ul>
      </div>
      <p>Érdemes a költözés napjára meleg italokat és váltócipőt is bekészíteni, hiszen a hideg idő gyorsan kimerítheti az embert. Tapasztalt költöztetőkkel a téli kihívások is könnyen kezelhetők, így új otthonodba való érkezés is örömteli élmény marad.</p>
    `
            }
        ]
    },

    projects: {
        title: "Áraink",
        subtitle: "Fix árak, rejtett költségek nélkül!",
        // A tablazat sorai. A `discounted` a promo-val csokkentett ar: amig a
        // promo.active true, az eredeti ar athuzva, mellette ez latszik.
        // Ha egy sorra nem jar kedvezmeny, eleg kihagyni a `discounted` mezot.
        priceList: [
            {
                label: "Autó + 1 sofőr",
                price: "8 990 Ft-tól",
                discounted: "8 090 Ft-tól",
                unit: "/ óra"
            },
            {
                label: "Autó + 1 sofőr + 1 rakodó",
                price: "15 990 Ft-tól",
                discounted: "14 390 Ft-tól",
                unit: "/ óra"
            },
            {
                label: "Kilóméter díj",
                sub: "(Budapest területén kívül)",
                price: "240 Ft",
                discounted: "216 Ft",
                unit: "/ km"
            },
            {
                label: "Kiszállási díj",
                price: "15 990 Ft",
                discounted: "14 390 Ft",
                unit: ""
            }
            // Korabban hasznalt, most kikapcsolt tetelek - ha ujra kellenek,
            // eleg visszatenni oket a listaba:
            // { label: "Minden további rakodó", price: "3 000 Ft-tól", unit: "/ óra" },
            // { label: "Doboz", price: "500 Ft", unit: "/ darab" },
            // { label: "Légpárnás fólia", price: "400 Ft", unit: "/ méter" },
            // { label: "Csomagoló fólia", price: "4 000 Ft", unit: "" },
            // { label: "Távhordás", price: "100 Ft", unit: "/ karton" },
            // { label: "Bútor távhordás", price: "500 Ft", unit: "/ db" },
            // { label: "Emelet pénz", price: "500 - 1 000 Ft", unit: "/ emelet" }
        ],
        projects: [

        ]
    }
}
